import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import React from 'react'
import DrawIcon from '@mui/icons-material/Draw';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PrintIcon from '@mui/icons-material/Print';
import BaseMapEsriIcon1 from "../../../assets/basemap-16.svg";
import MeasureEsriIcon from "../../../assets/measure-16.svg";
import EditIcon from '@mui/icons-material/Edit';
const ToolsMenu = ({anchor,open,onClose,pageConfig,setHideDrawer,tools}) => {
  return (
    <Menu 
    id='tools-menu'
    anchorEl={anchor}
    open={open}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    MenuListProps={{
      'aria-labelledby': 'basic-button',
    }}
    PaperProps={{
      style: {
        backgroundColor: '#0e6347',
        color: '#fff',
        fontFamily: 'poppins',
      }
      
    }}                     
>
  {pageConfig.widgets.bookmarks &&<MenuItem 
    onClick={(e) => {
      setHideDrawer(true);
      tools('bookmarks');
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }} 
  >
    <ListItemIcon>
       <BookmarkIcon style={{ color: "#fff" }}/>
    </ListItemIcon>Bookmarks
  </MenuItem>}
  {pageConfig.widgets.basemapGallery.show &&<MenuItem 
    onClick={(e) => {
      setHideDrawer(true)
      tools('basemapGallery')
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }} 
  >
    <ListItemIcon>
       <img alt='basemap' src={BaseMapEsriIcon1} />
    </ListItemIcon>Basemap Gallery
  </MenuItem>}
  {pageConfig.widgets.draw &&<MenuItem 
    onClick={(e) => {
      setHideDrawer(true)
      tools('DrawToolWidget')
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }}  
  >
    <ListItemIcon>
       <DrawIcon style={{ color: "#fff" }} />
    </ListItemIcon>Draw
  </MenuItem >}
  {pageConfig.widgets.editor &&<MenuItem 
    onClick={(e) => {
      setHideDrawer(true)
      tools('editorWidget')
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }} 
  >
    <ListItemIcon>
      <EditIcon style={{ color: "#fff" }} />
    </ListItemIcon>Edit
  </MenuItem>}
  {pageConfig.widgets.measure &&<MenuItem 
    onClick={(e) => {
      setHideDrawer(true)
      tools('measurementTool')
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }} 
  >
    <ListItemIcon>
      <img src={MeasureEsriIcon} alt="measure" />
    </ListItemIcon>Measure
  </MenuItem>}
  {pageConfig.widgets.print.show &&<MenuItem 
    onClick={(e) => {
      setHideDrawer(true)
      tools('PrintMapWidget')
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }} 
  >
    <ListItemIcon>
      <PrintIcon style={{ color: "#fff" }} />
    </ListItemIcon>Print
  </MenuItem>}
</Menu>
  )
}

export default ToolsMenu